import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { PRIVILEGE_ADMIN, PRIVILEGE_USER, P_LZCJ_TODAY, P_WGYC_ANYDAY, P_XXXW, T_SXWY_ZS } from '../app/privileges';
import HomePage from '../page/HomePage';
import LoginPage from '../page/LoginPage';
import WGYCAnydayPage from '../page/WGYC/WGYCAnydayPage';
import WGYCIcon from '../page/WGYC/WGYCIcon';
import AdminUserPage from '../page/admin/AdminUserPage';
import AdminUserSubscriptionPage from '../page/admin/AdminUserSubscriptionPage.jsx';
import HomeAdminPage from '../page/admin/HomeAdminPage';
import SystemSettingPage from '../page/admin/SystemSettingPage';
import LZCJIcon from '../page/tools/lazhucaiju/LZCJIcon';
import LZCJPage from '../page/tools/lazhucaiju/LZCJPage';
import SXWYIcon from '../page/tools/shengxiaowangyun/SXWYIcon';
import SXWYPage from '../page/tools/shengxiaowangyun/SXWYPage';
import SXWYZSIcon from '../page/tools/shengxiaowangyunzhongsheng/SXWYZSIcon';
import SXWYZSPage from '../page/tools/shengxiaowangyunzhongsheng/SXWYZSPage';
import XXXWIcon from '../page/tools/xinxiuxingwei/XXXWIcon.jsx';
import XXXWPage from '../page/tools/xinxiuxingwei/XXXWPage.jsx';
import HomeUserPage from '../page/user/HomeUserPage';
import UserSubscriptionPage from '../page/user/UserSubscriptionPage';
import UserToolsPage from '../page/user/UserToolsPage';
import { ProtectedLayout } from './ProtectedLayout';
import ErrorPage from "./error-page";

function renderRoutes(routes) {
    return routes.map((route) => (
        <Route key={route.path} path={route.path} element={renderRouteElement(route)} errorElement={route?.errorElement}>
            {route.child && renderRoutes(route.child)}
        </Route>
    ));
}
function renderRouteElement(route) {
    if (route.element === 'ProtectedLayout') {
        return <ProtectedLayout privilege={route.privilege} component={route.component} />
    } else {
        return route.element
    }
}

/*
const checkLZCJToday = async () => {
    try {
        // let res = await getLZCJCheck('2023-07-26');
        let res = await getLZCJCheck(moment().format('YYYY-MM-DD'));
        return res.data === true;
    } catch (e) {
        return false;
    }
}
*/

export const routerList = [
    {
        path: '/',
        errorElement: <ErrorPage />,
        child: [
            {
                path: '',
                element: <HomePage />
            },
            {
                path: 'login',
                element: <LoginPage />
            }
        ]
    },
    {
        path: '/user',
        name: '用户目录',
        element: 'ProtectedLayout',
        privilege: [PRIVILEGE_USER],
        child: [
            {
                path: '',
                name: '主页',
                element: <HomeUserPage />
            },
            {
                path: 'tools',
                name: '我的工具',
                element: <UserToolsPage />
            },
            {
                path: 'subscriptions',
                name: '我的订阅',
                element: <UserSubscriptionPage />
            }
        ]
    },
    {
        path: '/admin',
        name: '管理员目录',
        element: 'ProtectedLayout',
        privilege: [PRIVILEGE_ADMIN],
        child: [
            {
                path: '',
                name: '主页',
                element: <HomeAdminPage />
            },
            {
                path: 'user',
                name: '用户管理',
                element: <AdminUserPage />
            },
            {
                path: 'user/subscription',
                name: '用户订阅管理',
                element: <AdminUserSubscriptionPage />,
                notShow: true
            },
            {
                path: 'setting',
                name: '系统配置管理',
                element: <SystemSettingPage />
            }
        ]
    },
    {
        path: '/wgyc',
        name: '五癸运财',
        child: [
            {
                path: 'anyday',
                name: '每日做局',
                element: 'ProtectedLayout',
                privilege: [PRIVILEGE_USER],
                // privilege: [P_WGYC_ANYDAY],
                component: <WGYCAnydayPage />,
                tools: {
                    icon: <WGYCIcon />,
                    jumpPrivilege: [P_WGYC_ANYDAY],
                }
            }
        ]
    },
    {
        path: '/sxwy',
        name: '生肖旺运',
        child: [
            {
                path: 'year',
                name: '年份',
                element: 'ProtectedLayout',
                privilege: [PRIVILEGE_USER],
                component: <SXWYPage />,
                tools: {
                    icon: <SXWYIcon />
                }
            },
            {
                path: 'zhongsheng',
                name: '终身',
                element: 'ProtectedLayout',
                privilege: [PRIVILEGE_USER],
                component: <SXWYZSPage />,
                tools: {
                    icon: <SXWYZSIcon />,
                    jumpPrivilege: [T_SXWY_ZS],
                    jumpPrivilegeFailMsg: "账户开通半年后可使用",
                }
            }
        ]
    },
    {
        path: '/lzcj',
        name: '蜡烛财局',
        child: [
            {
                path: 'today',
                name: '今日',
                element: 'ProtectedLayout',
                privilege: [PRIVILEGE_USER],
                component: <LZCJPage />,
                tools: {
                    icon: <LZCJIcon />,
                    jumpPrivilege: [P_LZCJ_TODAY],
                    // preJump: checkLZCJToday,
                    // preJumpFailMsg: "今日无蜡烛财局"
                },
            }
        ]
    },
    {
        path: '/xxxw',
        name: '星宿风水',
        child: [
            {
                path: '',
                name: '星宿图画风水',
                element: 'ProtectedLayout',
                privilege: [PRIVILEGE_USER],
                component: <XXXWPage />,
                tools: {
                    icon: <XXXWIcon />,
                    jumpPrivilege: [P_XXXW],
                },
            }
        ]
    }
]

const URL_PREFIX = process.env.REACT_APP_URL_PREFIX || "";

const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            {renderRoutes(routerList)}
        </>
    ),
    {basename: URL_PREFIX}
);

export default router;